/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claim_Type_Missing_ParcelsInputs */

const en_claim_type_missing_parcels = /** @type {(inputs: Claim_Type_Missing_ParcelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing parcels`)
};

/**
* | output |
* | --- |
* | "Missing parcels" |
*
* @param {Claim_Type_Missing_ParcelsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const claim_type_missing_parcels = /** @type {((inputs?: Claim_Type_Missing_ParcelsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claim_Type_Missing_ParcelsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_claim_type_missing_parcels(inputs)
});